import { LoadingSkeleton } from "@faire/web/slate-deprecated/LoadingSkeleton";
import { Column, HorizontalLine } from "@faire/web/slate/Layout";
import { getSpacing, Spacer } from "@faire/web/slate/spacing";
import React, { Fragment } from "react";

export const SDUIFilterablePaginatedSectionFiltersLoadingSkeleton = () => (
  <Column>
    {Array.from({ length: 5 }).map((_, index) => (
      <Fragment key={index}>
        <Spacer width="3x" />
        <LoadingSkeleton width={getSpacing(120)} height={getSpacing(20)} />
        <Spacer width="3x" />
        <HorizontalLine />
      </Fragment>
    ))}
  </Column>
);
